import { Box, Typography } from "@mui/material";

type TitlesComponentProps = {
  title: string;
  onExpand?: () => void;
};

export default function TitlesComponent({ title, onExpand }: Readonly<TitlesComponentProps>) {
  return (
    <Box
      sx={{
        width: "100%",
        px: 3,
        py: 1.5,
        background: "#fff",
        borderRadius: "8px",
        borderBottom: "1px solid #EFF0F0",
        display: "inline-flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: 286, display: "inline-flex", flexDirection: "column", gap: 0.5 }}>
        <Typography
          sx={{
            color: "#000",
            fontSize: 16,
            fontFamily: "Poppins",
            fontWeight: 500,
            lineHeight: "19.2px",
          }}
        >
          {title}
        </Typography>
      </Box>

      {onExpand && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
          <Box
            onClick={onExpand}
            sx={{
              height: 26,
              px: 1,
              py: "6px",
              background: "#fff",
              boxShadow: "0px 0px 0px 1px rgba(0, 0, 0, 0.09)",
              overflow: "hidden",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              cursor: "pointer",
            }}
          >
            <Box
              component="img"
              src="/assets/icons/patient-table/ci_expand.svg"
              alt={title}
              sx={{ width: 24, height: 24, objectFit: "contain" }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
